import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createPartnerLeadContract,
  type CreatePartnerLeadRequest,
  type CreatePartnerLeadResponse
} from '@bliks-io/contracts';
import { apiClient } from '@/api/client';
import { partnerKeys } from '@/api/query-keys';

/**
 * Create a partner lead. The backend hands it to the existing n8n intake
 * pipeline (HubSpot create + association + enrichment). On success the leads
 * list is invalidated so the new lead shows up after the pipeline ran.
 */
export function useCreatePartnerLead() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreatePartnerLeadRequest): Promise<CreatePartnerLeadResponse> => {
      const { data: response } = await apiClient.post<CreatePartnerLeadResponse>(
        createPartnerLeadContract.path,
        data
      );
      return response;
    },
    onSuccess: (_response, lead) => {
      queryClient.invalidateQueries({ queryKey: partnerKeys.leads() });
      // The backend marked the contact the lead came from.
      if (lead.contactId) queryClient.invalidateQueries({ queryKey: partnerKeys.contacts() });
    }
  });
}
